import React from "react";
import { useUser } from "../contexts/UserContext";
import { Login } from "./Login";
import { Navigation } from "./Navigation";
import { ThesisTypes } from "./ThesisTypes";

export const App = () => {
  const { user } = useUser();

  return user ? (
    <>
      <Navigation />
      <ThesisTypes />
    </>
  ) : (
    <Login />
  );
}